import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';
import { Disclosure } from 'Components/ComponentLibrary/Organisms/Disclosure/Disclosure';
import { SecurityAlert } from 'Components/ComponentLibrary/Organisms/SecurityAlert';

export default buildFacetDesignOverride()
  .nameOverride('body', {
    _component: () => RichTextDisplay,
  }, overrideReadOnly)
  .nameOverride('disclosure', {
    _component: () => Disclosure,
  }, overrideReadOnly)
  .nameOverride('securityMessage', {
    _component: () => SecurityAlert,
  }, overrideReadOnly);
